import * as React from "react";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

TimeAgo.addLocale(en);

const timeAgo = new TimeAgo("en-US");

type Props = {
  value: string | Date;
};

const Timestamp = ({ value }: Props) => {
  if (typeof value === "string") value = new Date(value);
  return <span title={value.toLocaleString()}>{timeAgo.format(value)}</span>;
};

export default Timestamp;
